import { Box, Stack } from '@mui/material';
import { useState } from 'react';
import { TitlePages } from '@/components/Base/TitlePage';
import KpiComponent from '@/components/Base/KpiComponent';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import TableBasicRankRaioProfessores from '@/components/Base/TableBasicRankRaioProfessores';
import RankingComponent from '@/components/Base/RankingComponent';
import LoadingChart from './components/LoadingChart';
import { useRaioxProfessores } from '../raiox-alunos/api/getRaioxProfessores';

const RaioXProfessores = () => {
  const generateLastYears = (numYears) => {
    const currentYear = dayjs().year();
    return Array.from({ length: numYears }, (_, index) => currentYear - index).reverse();
  };
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));

  const filters = {
    ...(selectedYear && { year: selectedYear }),
    ...(selectedMonth && { month: selectedMonth }),
  };

  const { data: dataProfessor, isFetched, isFetching } = useRaioxProfessores(filters);

  const mappedProfessores = dataProfessor?.tableProfessores?.slice(0, 3).map((professor) => ({
    foto: professor.foto,
    rank: professor.rank,
    turma: '',
    aluno: professor.nome_professor,
  })) ?? [];


  return (
    <>
      <>
        <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <TitlePages title={'Professores'} />
        </Stack>

        <Box
          padding={'15px'}
          sx={{
            border: '1px solid rgba(176, 176, 176, 1)',
            background: '#fff',
            borderRadius: '14px',
          }}
        >
          <Stack flexDirection={'row'} gap={'8px'}>
            <Stack
              flexDirection="row"
              maxWidth="100%"
              gap="8px"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'thin',
                scrollbarColor: '#E04A4C #f1f1f1',
              }}
            >
              <KpiComponent title={'Médias de notas'} 
                value={dataProfessor?.kpis?.media_notas ?? '-'} 
                // value={"10"}
              />
              <KpiComponent title={'Maior resultado de avaliações'} 
                value={dataProfessor?.kpis?.maior_resultado_avaliacoes ?? '-'} 
                // value={"10"}
              />
              <KpiComponent title={'Maior índice de frequência'} 
                value={dataProfessor?.kpis?.maior_indice_frequencia ?? '-'} 
                // value={"10"}
              />
            </Stack>
          </Stack>
          <Box marginTop={'10px'} marginBottom={'25px'}>
            <PeriodFilterDash
              showPeriodFilter={false}
              showMonthFilter={true}
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              onStartDateChange={setSelectedStartDate}
              onEndDateChange={setSelectedEndDate}
              refetchDashboard={() => console.log('teste')}
              listYears={listYears}
              setSelectedYear={setSelectedYear}
              setSelectedMonth={setSelectedMonth}
              selectedYear={selectedYear}
              selectedMonth={selectedMonth}
            />
          </Box>
          
          <Stack flexDirection={'row'} gap={'30px'}>
            <Box width={'50%'} flex={1}>
              {!(mappedProfessores?.length > 0) && <LoadingChart loading={isFetching} />}
              {(mappedProfessores?.length > 0) && <RankingComponent data={mappedProfessores || []}/>}
            </Box>

            <Box width={'50%'} flex={1}>
              {!dataProfessor?.tableProfessores && <LoadingChart loading={isFetching} />}
              {dataProfessor?.tableProfessores && <TableBasicRankRaioProfessores data={dataProfessor.tableProfessores} />}
            </Box>
          </Stack>
        </Box>
      </>
    </>
  );
};

export default RaioXProfessores;
